import React from "react";
import back from "../image/back.png";

const StatutoryAudit = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };
  return (
    <>
      <div className="bg-white rounded-lg">
        {/* Background Section */}
        <div
          className="bg-cover bg-center h-64 flex flex-col justify-center items-center text-center"
          style={{
            backgroundImage: `url(${back})`,
          }}
        >
          <h1 className="text-3xl font-bold text-blue-700">Statutory Audit</h1>
          <p className="mt-2 max-w-3xl text-black font-semibold text-lg lg:text-2xl">Comprehensive Statutory Audit Services with Sanjay K Nathani & Co.</p>
        </div>

        {/* Description Section */}
        <div className="mt-6 px-6 lg:px-20">
          <p className="text-gray-700 leading-relaxed mb-6">
            In accordance with the Companies Act, all companies are required to
            undergo a statutory audit performed by a Chartered Accountant (CA).
            This process is crucial for upholding financial transparency and
            accountability by verifying the accuracy of financial statements
            and their adherence to established accounting standards.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6">
            Sanjay K Nathani & Co. proactively helps businesses comply with the
            Companies Act and maintain financial transparency through our
            comprehensive statutory audit services. Our team of expert CAs
            brings extensive experience across various sectors to every audit.
            Our statutory audit services include:
          </p>

          {/* List of Services */}
          <ol className="list-disc list-inside space-y-2 text-gray-700">
            <li>
              Comprehensive review and analysis of financial statements and
              records
            </li>
            <li>Identification of GST liabilities and obligations</li>
            <li>
              Preparation and submission of statutory audit reports as required
              by the Companies Act
            </li>
            <li>
              Representation before the GST Department in case of any disputes
              or inquiries
            </li>
            <li>Recommendations on GST planning and optimization strategies</li>
          </ol>

          <br />
          <p className="text-gray-700 leading-relaxed">
            Our statutory audit services employ the latest technology and
            software to ensure accuracy, efficiency, and a seamless experience.
            Our team of experts is equipped to provide customized solutions that
            address your specific business needs and statutory compliance
            mandates.
          </p>
           {/* List of Services */}
           {/* <ol className="list-disc list-inside space-y-2 text-gray-700">
            <li>Comprehensive review and analysis of financial and operational processes</li>
            <li>Identification of potential risks and weaknesses in internal controls</li>
            <li>Assessment of compliance with regulatory and industry standards</li>
            <li>Recommendations on process improvement and optimization strategies</li>
            <li>Recommendations on GST planning and optimization strategies</li>
            <li>Preparation and submission of internal audit reports</li>
          </ol> */}
          <br></br>
          {/* <p>We provide customized internal audit solutions tailored to your specific business needs and compliance requirements. To ensure accuracy, efficiency, and a hassle-free experience, we utilize the latest technology and software.</p> */}
        </div>

        {/* Contact Section */}
        <div className="mt-8 bg-gray-50 p-6 rounded-lg shadow-sm mx-6 lg:mx-20">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Get in touch</h2>
          <p className="text-gray-600 mb-6">
            If you have any queries or questions, please reach out to us by
            clicking on the contact button and filling out the form.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            {/* Make Appointment Button */}
            <button  onClick={handleAppointmentClick} className="px-6 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition duration-200">
              Make Appointment
            </button>

            {/* Contact Us Button */}
            <button className="px-6 py-2 bg-[#005A8C] text-white rounded hover:bg-blue-600 transition duration-200">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatutoryAudit;
